import { AnalyticsRangePreset } from "../../enums";
import { createAction, props } from "@ngrx/store";
import { CampaignDetailAnalyticsResponseDto } from "../../services/api";
import { AnalyticsFilters, AnalyticsSection, AnalyticsSections } from "./state";

export const setFilters = createAction("@analytics/set-filters", props<{ filters: Partial<AnalyticsFilters> }>());

/** Loads the given sections with the current filters or a preset override; a tab dispatches it on enter and when the filters change. */
export const loadSections = createAction("@analytics/load-sections", props<{ sections: AnalyticsSection[]; preset?: AnalyticsRangePreset }>());

export const loadSectionSuccess = createAction(
  "@analytics/load-section-success",
  props<{ section: AnalyticsSection; preset: AnalyticsRangePreset; data: AnalyticsSections[AnalyticsSection]["data"] }>(),
);

export const loadSectionFailure = createAction("@analytics/load-section-failure", props<{ section: AnalyticsSection; error: string }>());

/** Performance block on a campaign page (notification, coupon, gift card). */
export const loadCampaignDetail = createAction("@analytics/load-campaign-detail", props<{ campaignId: string }>());

export const loadCampaignDetailSuccess = createAction(
  "@analytics/load-campaign-detail-success",
  props<{ campaignId: string; data: CampaignDetailAnalyticsResponseDto }>(),
);

export const loadCampaignDetailFailure = createAction("@analytics/load-campaign-detail-failure", props<{ campaignId: string; error: string }>());

export const reset = createAction("@analytics/reset");
